// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-video-manage {

    width: 100%;
}

.top-video-manage h2 {

    margin-bottom: 25px;

    color: #ffffff;

    font-size: 28px;

    font-weight: 700;
}

.top-video-form {

    display: flex;

    gap: 12px;

    margin-bottom: 30px;
}

.top-video-form input {

    flex: 1 1;

    height: 50px;

    padding: 0 15px;

    border: 1px solid #374151;

    border-radius: 12px;

    background: #1f2937;

    color: #ffffff;
}

.top-video-form button {

    width: 120px;

    border: none;

    border-radius: 12px;

    background: #2563eb;

    color: white;

    cursor: pointer;
}

.top-video-list {

    display: flex;

    flex-direction: column;

    gap: 16px;
}

.top-video-card {

    display: flex;

    align-items: center;

    gap: 20px;

    padding: 16px;

    background: #1f2937;

    border: 1px solid #374151;

    border-radius: 16px;
}

.top-video-card img {

    width: 180px;

    height: 100px;

    object-fit: cover;

    border-radius: 12px;
}

.top-video-info {

    flex: 1 1;
}

.top-video-info h4 {

    margin: 0 0 10px 0;

    color: #ffffff;

    font-size: 18px;
}

.top-video-info a {

    color: #60a5fa;

    text-decoration: none;
}

.top-video-buttons {

    display: flex;

    gap: 10px;
}

.edit-btn {

    padding: 10px 16px;

    border: none;

    border-radius: 10px;

    background: #2563eb;

    color: white;

    cursor: pointer;
}

.delete-btn {

    padding: 10px 16px;

    border: none;

    border-radius: 10px;

    background: #ef4444;

    color: white;

    cursor: pointer;
}

.modal-overlay {

    position: fixed;

    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background: rgba(
            0,
            0,
            0,
            0.6
    );

    display: flex;

    justify-content: center;

    align-items: center;

    z-index: 9999;
}

.modal-box {

    width: 500px;

    background: #1f2937;

    border-radius: 16px;

    padding: 24px;
}

.modal-box h3 {

    color: white;

    margin-bottom: 20px;
}

.modal-box input {

    width: 100%;

    height: 50px;

    padding: 0 15px;

    border: 1px solid #374151;

    border-radius: 12px;

    background: #111827;

    color: white;

    box-sizing: border-box;
}

.modal-buttons {

    margin-top: 20px;

    display: flex;

    justify-content: flex-end;

    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AppTopVideoManage.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;;IAEnB,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;;IAEb,SAAS;;IAET,mBAAmB;AACvB;;AAEA;;IAEI,SAAO;;IAEP,YAAY;;IAEZ,eAAe;;IAEf,yBAAyB;;IAEzB,mBAAmB;;IAEnB,mBAAmB;;IAEnB,cAAc;AAClB;;AAEA;;IAEI,YAAY;;IAEZ,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;AACnB;;AAEA;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;AACb;;AAEA;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,aAAa;;IAEb,mBAAmB;;IAEnB,yBAAyB;;IAEzB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;;IAEZ,aAAa;;IAEb,iBAAiB;;IAEjB,mBAAmB;AACvB;;AAEA;;IAEI,SAAO;AACX;;AAEA;;IAEI,kBAAkB;;IAElB,cAAc;;IAEd,eAAe;AACnB;;AAEA;;IAEI,cAAc;;IAEd,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;;IAEb,SAAS;AACb;;AAEA;;IAEI,kBAAkB;;IAElB,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;;IAElB,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;AACnB;;AAEA;;IAEI,eAAe;;IAEf,MAAM;IACN,OAAO;;IAEP,WAAW;IACX,YAAY;;IAEZ;;;;;KAKC;;IAED,aAAa;;IAEb,uBAAuB;;IAEvB,mBAAmB;;IAEnB,aAAa;AACjB;;AAEA;;IAEI,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,aAAa;AACjB;;AAEA;;IAEI,YAAY;;IAEZ,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;;IAEX,YAAY;;IAEZ,eAAe;;IAEf,yBAAyB;;IAEzB,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;;IAEhB,aAAa;;IAEb,yBAAyB;;IAEzB,SAAS;AACb","sourcesContent":[".top-video-manage {\n\n    width: 100%;\n}\n\n.top-video-manage h2 {\n\n    margin-bottom: 25px;\n\n    color: #ffffff;\n\n    font-size: 28px;\n\n    font-weight: 700;\n}\n\n.top-video-form {\n\n    display: flex;\n\n    gap: 12px;\n\n    margin-bottom: 30px;\n}\n\n.top-video-form input {\n\n    flex: 1;\n\n    height: 50px;\n\n    padding: 0 15px;\n\n    border: 1px solid #374151;\n\n    border-radius: 12px;\n\n    background: #1f2937;\n\n    color: #ffffff;\n}\n\n.top-video-form button {\n\n    width: 120px;\n\n    border: none;\n\n    border-radius: 12px;\n\n    background: #2563eb;\n\n    color: white;\n\n    cursor: pointer;\n}\n\n.top-video-list {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 16px;\n}\n\n.top-video-card {\n\n    display: flex;\n\n    align-items: center;\n\n    gap: 20px;\n\n    padding: 16px;\n\n    background: #1f2937;\n\n    border: 1px solid #374151;\n\n    border-radius: 16px;\n}\n\n.top-video-card img {\n\n    width: 180px;\n\n    height: 100px;\n\n    object-fit: cover;\n\n    border-radius: 12px;\n}\n\n.top-video-info {\n\n    flex: 1;\n}\n\n.top-video-info h4 {\n\n    margin: 0 0 10px 0;\n\n    color: #ffffff;\n\n    font-size: 18px;\n}\n\n.top-video-info a {\n\n    color: #60a5fa;\n\n    text-decoration: none;\n}\n\n.top-video-buttons {\n\n    display: flex;\n\n    gap: 10px;\n}\n\n.edit-btn {\n\n    padding: 10px 16px;\n\n    border: none;\n\n    border-radius: 10px;\n\n    background: #2563eb;\n\n    color: white;\n\n    cursor: pointer;\n}\n\n.delete-btn {\n\n    padding: 10px 16px;\n\n    border: none;\n\n    border-radius: 10px;\n\n    background: #ef4444;\n\n    color: white;\n\n    cursor: pointer;\n}\n\n.modal-overlay {\n\n    position: fixed;\n\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n\n    background: rgba(\n            0,\n            0,\n            0,\n            0.6\n    );\n\n    display: flex;\n\n    justify-content: center;\n\n    align-items: center;\n\n    z-index: 9999;\n}\n\n.modal-box {\n\n    width: 500px;\n\n    background: #1f2937;\n\n    border-radius: 16px;\n\n    padding: 24px;\n}\n\n.modal-box h3 {\n\n    color: white;\n\n    margin-bottom: 20px;\n}\n\n.modal-box input {\n\n    width: 100%;\n\n    height: 50px;\n\n    padding: 0 15px;\n\n    border: 1px solid #374151;\n\n    border-radius: 12px;\n\n    background: #111827;\n\n    color: white;\n\n    box-sizing: border-box;\n}\n\n.modal-buttons {\n\n    margin-top: 20px;\n\n    display: flex;\n\n    justify-content: flex-end;\n\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
